<template>
  <div class="home-search">
    <search-form :keywords="keywords" />
    <div class="home-search-box">
      <div class="box-right">
        <div class="box-right-con">
          <div class="box-tabs">
            <div :class="[type==='1'?'tabs-active':'']" @click="typeHandelLoad('1')">解决方案（{{count.solutionCount}}）</div>
            <div :class="[type==='2'?'tabs-active':'']" @click="typeHandelLoad('2')">IoT硬件（{{count.iotCount}}）</div>
            <div :class="[type==='3'?'tabs-active':'']" @click="typeHandelLoad('3')">开源社区（{{count.knowledgeGatherCount}}）</div>
            <div :class="[type==='4'?'tabs-active':'']" @click="typeHandelLoad('4')">供应商（{{count.isvCount}}）</div>
          </div>
          <div class="list">
            <a-spin :spinning="loading" >
              <template v-if="list.length>0">
                <template v-if="type==='1'">
                  <SolutionCard v-for="el in list" :info="el" @goSolution="goSolution(el)"/>
                </template>
                <template v-if="type==='2'">
                  <IotCard v-for="el in list" :info="el" @openGraph="openGraph(el)"/>
                </template>
                <template v-if="type==='3'">
                  <ProfileCard v-for="el in list" :info="el" />
                </template>
                <template v-if="type==='4'">
                  <SupplierCard v-for="(el,i) in list" :info="el" :color-num="colorNum(i)"/>
                </template>
              </template>
              <a-empty v-else style="margin: 100px 0"/>
            </a-spin>
          </div>
        </div>
        <Relation ref="graphRef" />
        <a-pagination
            style="margin-top: 32px;text-align: center"
            :total="page.total"
            hideOnSinglePage
            :current="page.current"
            showQuickJumper
            :show-total="(total) => `共 ${total} 项`"
            @change="pageChange"
        />
      </div>
      <ConsultForm/>
    </div>
  </div>
</template>

<script>
import Relation from "./relation.vue";
import { mapGetters } from "vuex";
import SearchForm from "./modules/SearchForm";
import SolutionCard from '@/page/searchInfo/modules/solutionCard.vue'
import IotCard from '@/page/searchInfo/modules/iotCard.vue'
import ProfileCard from '@/page/searchInfo/modules/profileCard.vue'
import SupplierCard from '@/page/searchInfo/modules/supplierCard.vue'
import pagination from "@/page/components/pagination.vue";
import ConsultForm from '@/page/searchInfo/modules/consultForm.vue'
import {
  luceneSearchCount,
  luceneSearchIot,
  luceneSearchIsv,
  luceneSearchKnow,
  luceneSearchSolution
} from '@/api/lucene.js'
import {sliceArray} from '@/utils/processing.js'
export default {
  components: {
    Relation,
    SolutionCard,
    SearchForm,
    IotCard,
    ProfileCard,
    SupplierCard,
    pagination,
    ConsultForm
  },
  data() {
    return {
      spinShow:true,
      merchantShow: false,
      chipShow: false,
      devShow: false,
      embeddedShow: false,
      infoPage: {
        current: 1,
        size: 6,
      },
      enterpriseInfo: "", //公司信息
      socInfo: "", //SOC信息
      devInfoData: "", //开发板信息
      osInfo: "", //os信息
      chipId: "",
      devInfoId: "",
      osInfoId: "",
      socId: "",
      osId: "",
      merchantId: "",
      searchData: [],
      list: [],
      categories: ["IoT产品", "OS", "开发板", "SOC", "解决方案", "厂商"],
      randNum: 0,
      searchResultTypeMap: {
        1: {
          name: "解决方案",
          navigation: (item) => {
            console.log('------')
            let type = item.hotType;
            if (type == 2 || type == 3) {
              this.$router.push(`/solution/info?id=${item.id}`);
            } else if (type == 1) {
              this.$router.push(`/solution/internet_things?id=${item.id}`);
            } else if (type == 4 || type == 5) {
              this.$router.push(`/solution/ordinary_program?id=${item.id}`);
            } else if (type == 6) {
              this.$router.push(`/solution/digitizing?id=${item.id}`);
            }
          },
          catrgory: 4,
        },
        2: {
          name: "IoT产品",
          navigation: (item) => {
            this.$router.push(`/replace/info?id=${item.id}`);
          },
          catrgory: 0,
        },
        3: {
          name: "开发板",
          navigation: (item) => {
            this.$router.push(`/replace/productInfo/dev?id=${item.id}`);
          },
          catrgory: 2,
        },
        4: {
          name: "SOC",
          navigation: (item) => {
            this.$router.push(`/replace/productInfo/soc?id=${item.id}`);
          },
          catrgory: 3,
        },
        5: {
          name: "嵌入式OS",
          navigation: (item) => {
            this.$router.push(`/replace/productInfo/os?id=${item.id}`);
          },
          catrgory: 1,
        },
        6: {
          name: "硬件产品",
          navigation: (item) => {
            this.$router.push(`/replace/info?id=${item.id}`);
          },
          catrgory: 0,
        },
      },

      //========================new
      loading:false,
      type:'1',
      count:{},
      page: {
        current: 1,
        size: 10,
        total: 0,
      },
      iotAll:[],
    };
  },
  computed: {
    ...mapGetters(["isLogin"]),
    keywords() {
      return this.$route.query.val;
    },
  },
  mounted() {
    if (localStorage.getItem("searchData")) {
      this.searchData = JSON.parse(localStorage.getItem("searchData"));
    }
    this.typeHandel('1')
    this.randNumFun();
    this.loadCount()
  },
  methods: {

    //按顺序取颜色
    colorNum(index) {
      let id = Number(index) + 1;
      if (id <= 4) {
        return id;
      } else {
        let num = id - parseInt(String(id / 4)) * 4;
        if (num === 0) num = 4;
        return num;
      }
    },
    randNumFun() {
      this.randNum = Math.floor(Math.random() * 4) + 1;
    },
    consult() {
      window.open(
        `${process.env.VUE_APP_ACCOUNT_PREFIX}/userLayout/userScenes/add`,
        "_blank"
      );
    },

    async loadCount(){
      this.count=await luceneSearchCount(this.keywords)
    },

    goSolution(el){
      this.searchResultTypeMap[1].navigation(el)
    },

    openGraph(data) {
      this.$refs.graphRef.open(data.id, this.searchResultTypeMap[data.type].catrgory, data.name);
    },

    async loadSolution(params){
      this.loading=true
      let res=await luceneSearchSolution(params,{name:this.keywords,status:'2'})
      this.list=res.datSolutionList
      this.page.total=res.totalCount
      this.loading=false
    },

    async loadIot(params){
      this.loading=true
      let _params={...params,size:1000}
      let res=await luceneSearchIot(_params,{name:this.keywords})
      //开发板
      res.devboardList?.forEach(el=>{
        el.type=3
      })
      res.osList?.forEach(el=>{
        el.type=5
      })
      res.socList?.forEach(el=>{
        el.type=4
      })
      res.productList?.forEach(el=>{
        el.type=6
      })
      let allList=[...res.devboardList,...res.osList,...res.socList,...res.productList]
      allList.forEach((el)=>{
          el.discription=el.discription.replace(/<img[^>]*>/g, '')
      })
      this.iotAll=sliceArray(allList,this.page.size)
      this.list=this.iotAll[0]
      this.page.total=res.totalCount
      this.loading=false
    },

    async loadProfile(params){
      this.loading=true
      let res=await luceneSearchKnow(params,{name:this.keywords,status:'2'})
      this.list=res.datKnowledgeGatherList
      this.page.total=res.totalCount
      this.loading=false
    },

    async loadSupplier(params){
      this.loading=true
      let res=await luceneSearchIsv(params,{name:this.keywords,status:'2'})
      this.list=res.datIsvList
      this.page.total=res.totalCount
      this.loading=false
    },


    pageChange(val){
      this.page.current = val;
      if(this.type==='2'){
        this.list=this.iotAll[val-1]
      }else {
        this.typeHandel(this.type)
      }
    },

    typeHandelLoad(key){
      this.page.current=1
      this.typeHandel(key)
    },

    async typeHandel(key){
      this.type=key
      let params={
        current:this.page.current,
        size:this.page.size
      }
      if(key==='1'){
        await this.loadSolution(params)
      }
      if(key==='2'){
        await this.loadIot(params)
      }
      if(key==='3'){
        await this.loadProfile(params)
      }
      if(key==='4'){
        await this.loadSupplier(params)
      }
    },

  },
  watch: {
    keywords() {
      this.merchantShow = false;
      this.chipShow = false;
      this.devShow = false;
      this.embeddedShow = false;
      this.typeHandel('1')
      this.loadCount()
    },
  },
};
</script>

<style lang="scss" scoped>
.home-search{
  flex: auto;
  display: flex;
  flex-direction: column;
}
.home-search-box{
  width: 1280px;
  padding: 24px 0 64px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: start;
}
.box-right-con{
  width: 880px;
  background: #FFF;
  .box-tabs{
    display: flex;
    height: 48px;
    background: #F0F3F8;
    >div{
      width: 156px;
      font-weight: 400;
      font-size: 14px;
      color: #262626;
      line-height: 48px;
      text-align: center;
      cursor: pointer;
    }
    >.tabs-active{
      color: #EA0B06;
      position: relative;
      background: #fff;
      &::before{
        position: absolute;
        content: '';
        width: 156px;
        height: 4px;
        background: #EA0B06;
        top: 0;
        left: 0;
      }
    }
  }
  .list{
    min-height:170px;
    ::v-deep .card:last-child{
      border-bottom: none;
    }
  }
}
</style>

